module.exports = __webpack_public_path__ + "img/薬野龍之介.f2d986f4.jpg";